export const countries = [
    {
        "_id": "af",
        "code": "93",
        "label": "+93 (Afghanistan)"
    },
    {
        "_id": "al",
        "code": "355",
        "label": "+355 (Albania)"
    },
    {
        "_id": "dz",
        "code": "213",
        "label": "+213 (Algeria)"
    },
    {
        "_id": "ad",
        "code": "376",
        "label": "+376 (Andorra)"
    },
    {
        "_id": "ao",
        "code": "244",
        "label": "+244 (Angola)"
    },
    {
        "_id": "ag",
        "code": "1268",
        "label": "+1268 (Antigua and Barbuda)"
    },
    {
        "_id": "ar",
        "code": "54",
        "label": "+54 (Argentina)"
    },
    {
        "_id": "am",
        "code": "374",
        "label": "+374 (Armenia)"
    },
    {
        "_id": "aw",
        "code": "297",
        "label": "+297 (Aruba)"
    },
    {
        "_id": "au",
        "code": "61",
        "label": "+61 (Australia)"
    },
    {
        "_id": "at",
        "code": "43",
        "label": "+43 (Austria)"
    },
    {
        "_id": "az",
        "code": "994",
        "label": "+994 (Azerbaijan)"
    },
    {
        "_id": "bs",
        "code": "1242",
        "label": "+1242 (Bahamas)"
    },
    {
        "_id": "bh",
        "code": "973",
        "label": "+973 (Bahrain)"
    },
    {
        "_id": "bd",
        "code": "880",
        "label": "+880 (Bangladesh)"
    },
    {
        "_id": "bb",
        "code": "1246",
        "label": "+1246 (Barbados)"
    },
    {
        "_id": "by",
        "code": "375",
        "label": "+375 (Belarus)"
    },
    {
        "_id": "be",
        "code": "32",
        "label": "+32 (Belgium)"
    },
    {
        "_id": "bz",
        "code": "501",
        "label": "+501 (Belize)"
    },
    {
        "_id": "bj",
        "code": "229",
        "label": "+229 (Benin)"
    },
    {
        "_id": "bt",
        "code": "975",
        "label": "+975 (Bhutan)"
    },
    {
        "_id": "bo",
        "code": "591",
        "label": "+591 (Bolivia)"
    },
    {
        "_id": "ba",
        "code": "387",
        "label": "+387 (Bosnia and Herzegovina)"
    },
    {
        "_id": "bw",
        "code": "267",
        "label": "+267 (Botswana)"
    },
    {
        "_id": "br",
        "code": "55",
        "label": "+55 (Brazil)"
    },
    {
        "_id": "io",
        "code": "246",
        "label": "+246 (British Indian Ocean Territory)"
    },
    {
        "_id": "bn",
        "code": "673",
        "label": "+673 (Brunei)"
    },
    {
        "_id": "bg",
        "code": "359",
        "label": "+359 (Bulgaria)"
    },
    {
        "_id": "bf",
        "code": "226",
        "label": "+226 (Burkina Faso)"
    },
    {
        "_id": "bi",
        "code": "257",
        "label": "+257 (Burundi)"
    },
    {
        "_id": "kh",
        "code": "855",
        "label": "+855 (Cambodia)"
    },
    {
        "_id": "cm",
        "code": "237",
        "label": "+237 (Cameroon)"
    },
    {
        "_id": "ca",
        "code": "1",
        "label": "+1 (Canada)"
    },
    {
        "_id": "cv",
        "code": "238",
        "label": "+238 (Cape Verde)"
    },
    {
        "_id": "bq",
        "code": "599",
        "label": "+599 (Caribbean Netherlands)"
    },
    {
        "_id": "cf",
        "code": "236",
        "label": "+236 (Central African Republic)"
    },
    {
        "_id": "td",
        "code": "235",
        "label": "+235 (Chad)"
    },
    {
        "_id": "cl",
        "code": "56",
        "label": "+56 (Chile)"
    },
    {
        "_id": "cn",
        "code": "86",
        "label": "+86 (China)"
    },
    {
        "_id": "co",
        "code": "57",
        "label": "+57 (Colombia)"
    },
    {
        "_id": "km",
        "code": "269",
        "label": "+269 (Comoros)"
    },
    {
        "_id": "cd",
        "code": "243",
        "label": "+243 (Congo)"
    },
    {
        "_id": "cg",
        "code": "242",
        "label": "+242 (Congo)"
    },
    {
        "_id": "cr",
        "code": "506",
        "label": "+506 (Costa Rica)"
    },
    {
        "_id": "ci",
        "code": "225",
        "label": "+225 (Côte d’Ivoire)"
    },
    {
        "_id": "hr",
        "code": "385",
        "label": "+385 (Croatia)"
    },
    {
        "_id": "cu",
        "code": "53",
        "label": "+53 (Cuba)"
    },
    {
        "_id": "cw",
        "code": "599",
        "label": "+599 (Curaçao)"
    },
    {
        "_id": "cy",
        "code": "357",
        "label": "+357 (Cyprus)"
    },
    {
        "_id": "cz",
        "code": "420",
        "label": "+420 (Czech Republic)"
    },
    {
        "_id": "dk",
        "code": "45",
        "label": "+45 (Denmark)"
    },
    {
        "_id": "dj",
        "code": "253",
        "label": "+253 (Djibouti)"
    },
    {
        "_id": "dm",
        "code": "1767",
        "label": "+1767 (Dominica)"
    },
    {
        "_id": "do",
        "code": "1",
        "label": "+1 (Dominican Republic)"
    },
    {
        "_id": "ec",
        "code": "593",
        "label": "+593 (Ecuador)"
    },
    {
        "_id": "eg",
        "code": "20",
        "label": "+20 (Egypt)"
    },
    {
        "_id": "sv",
        "code": "503",
        "label": "+503 (El Salvador)"
    },
    {
        "_id": "gq",
        "code": "240",
        "label": "+240 (Equatorial Guinea)"
    },
    {
        "_id": "er",
        "code": "291",
        "label": "+291 (Eritrea)"
    },
    {
        "_id": "ee",
        "code": "372",
        "label": "+372 (Estonia)"
    },
    {
        "_id": "et",
        "code": "251",
        "label": "+251 (Ethiopia)"
    },
    {
        "_id": "fj",
        "code": "679",
        "label": "+679 (Fiji)"
    },
    {
        "_id": "fi",
        "code": "358",
        "label": "+358 (Finland)"
    },
    {
        "_id": "fr",
        "code": "33",
        "label": "+33 (France)"
    },
    {
        "_id": "gf",
        "code": "594",
        "label": "+594 (French Guiana)"
    },
    {
        "_id": "pf",
        "code": "689",
        "label": "+689 (French Polynesia)"
    },
    {
        "_id": "ga",
        "code": "241",
        "label": "+241 (Gabon)"
    },
    {
        "_id": "gm",
        "code": "220",
        "label": "+220 (Gambia)"
    },
    {
        "_id": "ge",
        "code": "995",
        "label": "+995 (Georgia)"
    },
    {
        "_id": "de",
        "code": "49",
        "label": "+49 (Germany)"
    },
    {
        "_id": "gh",
        "code": "233",
        "label": "+233 (Ghana)"
    },
    {
        "_id": "gr",
        "code": "30",
        "label": "+30 (Greece)"
    },
    {
        "_id": "gd",
        "code": "1473",
        "label": "+1473 (Grenada)"
    },
    {
        "_id": "gp",
        "code": "590",
        "label": "+590 (Guadeloupe)"
    },
    {
        "_id": "gu",
        "code": "1671",
        "label": "+1671 (Guam)"
    },
    {
        "_id": "gt",
        "code": "502",
        "label": "+502 (Guatemala)"
    },
    {
        "_id": "gn",
        "code": "224",
        "label": "+224 (Guinea)"
    },
    {
        "_id": "gw",
        "code": "245",
        "label": "+245 (Guinea-Bissau)"
    },
    {
        "_id": "gy",
        "code": "592",
        "label": "+592 (Guyana)"
    },
    {
        "_id": "ht",
        "code": "509",
        "label": "+509 (Haiti)"
    },
    {
        "_id": "hn",
        "code": "504",
        "label": "+504 (Honduras)"
    },
    {
        "_id": "hk",
        "code": "852",
        "label": "+852 (Hong Kong)"
    },
    {
        "_id": "hu",
        "code": "36",
        "label": "+36 (Hungary)"
    },
    {
        "_id": "is",
        "code": "354",
        "label": "+354 (Iceland)"
    },
    {
        "_id": "in",
        "code": "91",
        "label": "+91 (India)"
    },
    {
        "_id": "_id",
        "code": "62",
        "label": "+62 (Indonesia)"
    },
    {
        "_id": "ir",
        "code": "98",
        "label": "+98 (Iran)"
    },
    {
        "_id": "iq",
        "code": "964",
        "label": "+964 (Iraq)"
    },
    {
        "_id": "ie",
        "code": "353",
        "label": "+353 (Ireland)"
    },
    {
        "_id": "il",
        "code": "972",
        "label": "+972 (Israel)"
    },
    {
        "_id": "it",
        "code": "39",
        "label": "+39 (Italy)"
    },
    {
        "_id": "jm",
        "code": "1876",
        "label": "+1876 (Jamaica)"
    },
    {
        "_id": "jp",
        "code": "81",
        "label": "+81 (Japan)"
    },
    {
        "_id": "jo",
        "code": "962",
        "label": "+962 (Jordan)"
    },
    {
        "_id": "kz",
        "code": "7",
        "label": "+7 (Kazakhstan)"
    },
    {
        "_id": "ke",
        "code": "254",
        "label": "+254 (Kenya)"
    },
    {
        "_id": "ki",
        "code": "686",
        "label": "+686 (Kiribati)"
    },
    {
        "_id": "xk",
        "code": "383",
        "label": "+383 (Kosovo)"
    },
    {
        "_id": "kw",
        "code": "965",
        "label": "+965 (Kuwait)"
    },
    {
        "_id": "kg",
        "code": "996",
        "label": "+996 (Kyrgyzstan)"
    },
    {
        "_id": "la",
        "code": "856",
        "label": "+856 (Laos)"
    },
    {
        "_id": "lv",
        "code": "371",
        "label": "+371 (Latvia)"
    },
    {
        "_id": "lb",
        "code": "961",
        "label": "+961 (Lebanon)"
    },
    {
        "_id": "ls",
        "code": "266",
        "label": "+266 (Lesotho)"
    },
    {
        "_id": "lr",
        "code": "231",
        "label": "+231 (Liberia)"
    },
    {
        "_id": "ly",
        "code": "218",
        "label": "+218 (Libya)"
    },
    {
        "_id": "li",
        "code": "423",
        "label": "+423 (Liechtenstein)"
    },
    {
        "_id": "lt",
        "code": "370",
        "label": "+370 (Lithuania)"
    },
    {
        "_id": "lu",
        "code": "352",
        "label": "+352 (Luxembourg)"
    },
    {
        "_id": "mo",
        "code": "853",
        "label": "+853 (Macau)"
    },
    {
        "_id": "mk",
        "code": "389",
        "label": "+389 (Macedonia)"
    },
    {
        "_id": "mg",
        "code": "261",
        "label": "+261 (Madagascar)"
    },
    {
        "_id": "mw",
        "code": "265",
        "label": "+265 (Malawi)"
    },
    {
        "_id": "my",
        "code": "60",
        "label": "+60 (Malaysia)"
    },
    {
        "_id": "mv",
        "code": "960",
        "label": "+960 (Maldives)"
    },
    {
        "_id": "ml",
        "code": "223",
        "label": "+223 (Mali)"
    },
    {
        "_id": "mt",
        "code": "356",
        "label": "+356 (Malta)"
    },
    {
        "_id": "mh",
        "code": "692",
        "label": "+692 (Marshall Islands)"
    },
    {
        "_id": "mq",
        "code": "596",
        "label": "+596 (Martinique)"
    },
    {
        "_id": "mr",
        "code": "222",
        "label": "+222 (Mauritania)"
    },
    {
        "_id": "mu",
        "code": "230",
        "label": "+230 (Mauritius)"
    },
    {
        "_id": "mx",
        "code": "52",
        "label": "+52 (Mexico)"
    },
    {
        "_id": "fm",
        "code": "691",
        "label": "+691 (Micronesia)"
    },
    {
        "_id": "md",
        "code": "373",
        "label": "+373 (Moldova)"
    },
    {
        "_id": "mc",
        "code": "377",
        "label": "+377 (Monaco)"
    },
    {
        "_id": "mn",
        "code": "976",
        "label": "+976 (Mongolia)"
    },
    {
        "_id": "me",
        "code": "382",
        "label": "+382 (Montenegro)"
    },
    {
        "_id": "ma",
        "code": "212",
        "label": "+212 (Morocco)"
    },
    {
        "_id": "mz",
        "code": "258",
        "label": "+258 (Mozambique)"
    },
    {
        "_id": "mm",
        "code": "95",
        "label": "+95 (Myanmar)"
    },
    {
        "_id": "na",
        "code": "264",
        "label": "+264 (Namibia)"
    },
    {
        "_id": "nr",
        "code": "674",
        "label": "+674 (Nauru)"
    },
    {
        "_id": "np",
        "code": "977",
        "label": "+977 (Nepal)"
    },
    {
        "_id": "nl",
        "code": "31",
        "label": "+31 (Netherlands)"
    },
    {
        "_id": "nc",
        "code": "687",
        "label": "+687 (New Caledonia)"
    },
    {
        "_id": "nz",
        "code": "64",
        "label": "+64 (New Zealand)"
    },
    {
        "_id": "ni",
        "code": "505",
        "label": "+505 (Nicaragua)"
    },
    {
        "_id": "ne",
        "code": "227",
        "label": "+227 (Niger)"
    },
    {
        "_id": "ng",
        "code": "234",
        "label": "+234 (Nigeria)"
    },
    {
        "_id": "kp",
        "code": "850",
        "label": "+850 (North Korea)"
    },
    {
        "_id": "no",
        "code": "47",
        "label": "+47 (Norway)"
    },
    {
        "_id": "om",
        "code": "968",
        "label": "+968 (Oman)"
    },
    {
        "_id": "pk",
        "code": "92",
        "label": "+92 (Pakistan)"
    },
    {
        "_id": "pw",
        "code": "680",
        "label": "+680 (Palau)"
    },
    {
        "_id": "ps",
        "code": "970",
        "label": "+970 (Palestine)"
    },
    {
        "_id": "pa",
        "code": "507",
        "label": "+507 (Panama)"
    },
    {
        "_id": "pg",
        "code": "675",
        "label": "+675 (Papua New Guinea)"
    },
    {
        "_id": "py",
        "code": "595",
        "label": "+595 (Paraguay)"
    },
    {
        "_id": "pe",
        "code": "51",
        "label": "+51 (Peru)"
    },
    {
        "_id": "ph",
        "code": "63",
        "label": "+63 (Philippines)"
    },
    {
        "_id": "pl",
        "code": "48",
        "label": "+48 (Poland)"
    },
    {
        "_id": "pt",
        "code": "351",
        "label": "+351 (Portugal)"
    },
    {
        "_id": "pr",
        "code": "1",
        "label": "+1 (Puerto Rico)"
    },
    {
        "_id": "qa",
        "code": "974",
        "label": "+974 (Qatar)"
    },
    {
        "_id": "re",
        "code": "262",
        "label": "+262 (Réunion)"
    },
    {
        "_id": "ro",
        "code": "40",
        "label": "+40 (Romania)"
    },
    {
        "_id": "ru",
        "code": "7",
        "label": "+7 (Russia)"
    },
    {
        "_id": "rw",
        "code": "250",
        "label": "+250 (Rwanda)"
    },
    {
        "_id": "kn",
        "code": "1869",
        "label": "+1869 (Saint Kitts and Nevis)"
    },
    {
        "_id": "lc",
        "code": "1758",
        "label": "+1758 (Saint Lucia)"
    },
    {
        "_id": "vc",
        "code": "1784",
        "label": "+1784 (Saint Vincent and the Grenadines)"
    },
    {
        "_id": "ws",
        "code": "685",
        "label": "+685 (Samoa)"
    },
    {
        "_id": "sm",
        "code": "378",
        "label": "+378 (San Marino)"
    },
    {
        "_id": "st",
        "code": "239",
        "label": "+239 (São Tomé and Príncipe)"
    },
    {
        "_id": "sa",
        "code": "966",
        "label": "+966 (Saudi Arabia)"
    },
    {
        "_id": "sn",
        "code": "221",
        "label": "+221 (Senegal)"
    },
    {
        "_id": "rs",
        "code": "381",
        "label": "+381 (Serbia)"
    },
    {
        "_id": "sc",
        "code": "248",
        "label": "+248 (Seychelles)"
    },
    {
        "_id": "sl",
        "code": "232",
        "label": "+232 (Sierra Leone)"
    },
    {
        "_id": "sg",
        "code": "65",
        "label": "+65 (Singapore)"
    },
    {
        "_id": "sk",
        "code": "421",
        "label": "+421 (Slovakia)"
    },
    {
        "_id": "si",
        "code": "386",
        "label": "+386 (Slovenia)"
    },
    {
        "_id": "sb",
        "code": "677",
        "label": "+677 (Solomon Islands)"
    },
    {
        "_id": "so",
        "code": "252",
        "label": "+252 (Somalia)"
    },
    {
        "_id": "za",
        "code": "27",
        "label": "+27 (South Africa)"
    },
    {
        "_id": "kr",
        "code": "82",
        "label": "+82 (South Korea)"
    },
    {
        "_id": "ss",
        "code": "211",
        "label": "+211 (South Sudan)"
    },
    {
        "_id": "es",
        "code": "34",
        "label": "+34 (Spain)"
    },
    {
        "_id": "lk",
        "code": "94",
        "label": "+94 (Sri Lanka)"
    },
    {
        "_id": "sd",
        "code": "249",
        "label": "+249 (Sudan)"
    },
    {
        "_id": "sr",
        "code": "597",
        "label": "+597 (Suriname)"
    },
    {
        "_id": "sz",
        "code": "268",
        "label": "+268 (Swaziland)"
    },
    {
        "_id": "se",
        "code": "46",
        "label": "+46 (Sweden)"
    },
    {
        "_id": "ch",
        "code": "41",
        "label": "+41 (Switzerland)"
    },
    {
        "_id": "sy",
        "code": "963",
        "label": "+963 (Syria)"
    },
    {
        "_id": "tw",
        "code": "886",
        "label": "+886 (Taiwan)"
    },
    {
        "_id": "tj",
        "code": "992",
        "label": "+992 (Tajikistan)"
    },
    {
        "_id": "tz",
        "code": "255",
        "label": "+255 (Tanzania)"
    },
    {
        "_id": "th",
        "code": "66",
        "label": "+66 (Thailand)"
    },
    {
        "_id": "tl",
        "code": "670",
        "label": "+670 (Timor-Leste)"
    },
    {
        "_id": "tg",
        "code": "228",
        "label": "+228 (Togo)"
    },
    {
        "_id": "to",
        "code": "676",
        "label": "+676 (Tonga)"
    },
    {
        "_id": "tt",
        "code": "1868",
        "label": "+1868 (Trin_idad and Tobago)"
    },
    {
        "_id": "tn",
        "code": "216",
        "label": "+216 (Tunisia)"
    },
    {
        "_id": "tr",
        "code": "90",
        "label": "+90 (Turkey)"
    },
    {
        "_id": "tm",
        "code": "993",
        "label": "+993 (Turkmenistan)"
    },
    {
        "_id": "tv",
        "code": "688",
        "label": "+688 (Tuvalu)"
    },
    {
        "_id": "ug",
        "code": "256",
        "label": "+256 (Uganda)"
    },
    {
        "_id": "ua",
        "code": "380",
        "label": "+380 (Ukraine)"
    },
    {
        "_id": "ae",
        "code": "971",
        "label": "+971 (United Arab Emirates)"
    },
    {
        "_id": "gb",
        "code": "44",
        "label": "+44 (United Kingdom)"
    },
    {
        "_id": "us",
        "code": "1",
        "label": "+1 (United States)"
    },
    {
        "_id": "uy",
        "code": "598",
        "label": "+598 (Uruguay)"
    },
    {
        "_id": "uz",
        "code": "998",
        "label": "+998 (Uzbekistan)"
    },
    {
        "_id": "vu",
        "code": "678",
        "label": "+678 (Vanuatu)"
    },
    {
        "_id": "va",
        "code": "39",
        "label": "+39 (Vatican City)"
    },
    {
        "_id": "ve",
        "code": "58",
        "label": "+58 (Venezuela)"
    },
    {
        "_id": "vn",
        "code": "84",
        "label": "+84 (Vietnam)"
    },
    {
        "_id": "ye",
        "code": "967",
        "label": "+967 (Yemen)"
    },
    {
        "_id": "zm",
        "code": "260",
        "label": "+260 (Zambia)"
    },
    {
        "_id": "zw",
        "code": "263",
        "label": "+263 (Zimbabwe)"
    }
];

export default countries;